import { useState } from 'react';

import { isStandalone } from '../../utils/pwa';
import { useDialogOpen } from '../../utils/useDialogOpen';
import { usePushState } from '../../utils/usePushState';
import { PushContext } from './pwaContext';
import { PushOptInSheet } from './PushOptInSheet';

// Push notifications on the signed-in pages. `busy` holds the installed app's own offer back (a guided session), as any
// open window does
export const PushProvider = ({ busy = false, children }) => {
  const [standalone] = useState(() => isStandalone());
  const windowOpen = useDialogOpen(standalone);
  const { state, sheet } = usePushState({ busy: busy || windowOpen });
  return (
    <PushContext.Provider value={state}>
      {children}
      <PushOptInSheet {...sheet} />
    </PushContext.Provider>
  );
};
